
import Vue from 'vue'

export default Vue.extend({
  name: 'ProfileCompleteness',
  mounted() {
    this.refresh()
  },
  props: {
    steps: {
      type: Array,
    },
  },
  data: () => ({
    stepWidth: 0,
    percentage: 100,
  }),
  methods: {
    onResize: function () {
      if (!this.$refs.div) {
        return
      }
      if (!('clientWidth' in this.$refs.div)) {
        return
      }
      if (this.$vuetify.breakpoint.xs) {
        this.stepWidth = this.$refs.div.clientWidth - 1
        return
      }

      this.stepWidth = this.$refs.div.clientWidth / this.steps.length - 1
    },
    refresh() {
      this.onResize()
      this.percentage = 100 / (this.steps.length + 1)
    },
  },
  watch: {
    steps: function () {
      this.refresh()
    },
  },
})
